module.exports = __webpack_public_path__ + "media/images/mobile/city_img/a1-8ef08e208a8e007288c394d40a53b863.jpg";